module.exports = __webpack_public_path__ + "img/403-forbidden.7bf7cdf.png";